import React from 'react';
import PropTypes from 'prop-types';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box } from '@mui/material';
import AmploChip from '../Controls/AmploChip';

const styles = {
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    overflow: 'scroll',
    '& > *': {
      margin: (theme) => theme.spacing(0.5),
    },
    position: 'relative',
  },
}

export default function QuickAdd({ groups, selected, onSelect }) {
  

  const handleClick = (id) => () => {
    onSelect(id);
  };

  const handleDelete = () => () => {
    onSelect('');
  };

  return (
    <Box sx={styles.root}>
      {groups.map((g) => {
        const groupSelected = selected === g._id;
        return (
          <AmploChip
            key={g._id}
            label={`#${g.displayGroupName}`}
            color={groupSelected ? 'primary' : 'default'}
            variant={groupSelected ? 'default' : 'outlined'}
            onClick={handleClick(g._id)}
            onDelete={groupSelected ? handleDelete(g._id) : null}
            deleteIcon={<CloseRoundedIcon />}
          />
        );
      })}
    </Box>
  );
}

QuickAdd.propTypes = {
  groups: PropTypes.array,
  selected: PropTypes.string,
  onSelect: PropTypes.func,
};
